import React, { useState } from "react";

export default function CookieBanner() {
  const [accepted, setAccepted] = useState(() => {
    return localStorage.getItem("cr_cookie_accepted") === "true";
  });

  function handleAccept() {
    localStorage.setItem("cr_cookie_accepted", "true");
    setAccepted(true);
  }

  if (accepted) return null;

  return (
    <div className="cookie-banner" role="alert">
      <p className="cookie-banner-text">
        We use cookies to keep this site running smoothly and remember your
        preferences. No tracking, no ads — just the basics to make things work.
      </p>
      <button
        type="button"
        className="btn btn-primary cookie-banner-btn"
        onClick={handleAccept}
      >
        Got it
      </button>
    </div>
  );
}
